import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PhoneField from 'components/v2/forms/PhoneField';
import { withTranslation } from 'react-i18next';
import DeleteButton from 'components/v2/buttons/DeleteButton';

class ContactField extends Component {
  static propTypes = {
    contact: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }),
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
  };
  handleNameChange = (e) => this.props.onChange('name', e.target.value);
  handleEmailChange = (e) => this.props.onChange('email', e.target.value);
  handlePhoneChange = (number) => this.props.onChange('phone', number);
  handleRemove = () => this.props.onRemove();

  render() {
    const {
      id,
      contact: { name, email, phone },
      t,
    } = this.props;
    return (
      <div className="flex flex-wrap items-center -mx-2">
        <div className="md:w-1/4 w-full px-2">
          <fieldset className="">
            <input
              className="form-field block mb-4 md:mb-0 w-full"
              value={name}
              placeholder={t('CONTACTS_NAME')}
              onChange={this.handleNameChange}
            />
          </fieldset>
        </div>
        <div className="md:w-1/4 w-full px-2">
          <fieldset className="">
            <input
              type="email"
              className="form-field block mb-4 md:mb-0 w-full"
              value={email}
              placeholder={t('CONTACTS_EMAIL')}
              onChange={this.handleEmailChange}
            />
          </fieldset>
        </div>
        <div className="md:w-1/4 w-full px-2">
          <PhoneField
            value={phone}
            id={id}
            onChange={this.handlePhoneChange}
            className="md:mb-0 mb-4"
          />
        </div>
        <div className="flex-1 px-2">
          <DeleteButton onClick={this.handleRemove} />
        </div>
      </div>
    );
  }
}

export default withTranslation()(ContactField);
